import { GLTF } from 'three/examples/jsm/loaders/GLTFLoader';
import CruciblePiece from './cruciblePiece';
import * as config from '../config.json';
import { GyroscopeConfig } from '../config';

export class Gyroscope extends CruciblePiece {
  protected _config: GyroscopeConfig;
  protected _pivotNodes: THREE.Object3D[];
  protected _rotationSpeeds: number[];
  protected _fixedYAxisPivot: THREE.Object3D[];
  protected _fixedZAxisPivot: THREE.Object3D[];
  protected _fixedXAxisPivot: THREE.Object3D[];

  constructor() {
    super();
    this._config = config.gyroscope;
    this._rotationSpeeds = this._config.pivotRotationSpeeds;
    this._pivotNodes = [];
    this._fixedYAxisPivot = [];
    this._fixedXAxisPivot = [];
    this._fixedZAxisPivot = [];
  }

  setup(gltf: GLTF) {
    // Clean crucible piece objects when setting up, in case a second crucible was loaded
    this._pivotNodes = [];
    this._fixedYAxisPivot = [];
    this._fixedXAxisPivot = [];
    this._fixedZAxisPivot = [];

    // Reset group object with gltf contents
    this.group = gltf.scene;
    this.group.scale.set(2, 2, 2); // This should be removed with final models

    this.group.traverse((node: any) => {
      if (node.isMesh) {
        node.castShadow = true;
        node.receiveShadow = true;
        if (node.material.map) node.material.map.anisotropy = 16;
      }

      if (node.name.includes(this._config.fixedXAxisPivot)) {
        this._fixedXAxisPivot.push(node);
      }

      if (node.name.includes(this._config.fixedYAxisPivot)) {
        this._fixedYAxisPivot.push(node);
      }

      if (node.name.includes(this._config.fixedZAxisPivot)) {
        this._fixedZAxisPivot.push(node);
      }
    });

    this._config.pivotNodeNames.forEach((pivotNodeName) => {
      const pivotNode = this.group.getObjectByName(pivotNodeName);
      if (pivotNode) {
        this._pivotNodes.push(pivotNode);
      }
    });
  }

  animate(timeElapsed: number) {
    if (this._fixedYAxisPivot.length > 0) {
      this._fixedYAxisPivot.forEach((node, i) => {
        let factor = 1;
        if (i % 2 !== 0) {
          factor = -1;
        }
        node.rotation.y += this._rotationSpeeds[i] * timeElapsed * factor;
      });
    }

    if (this._fixedZAxisPivot.length > 0) {
      this._fixedZAxisPivot.forEach((node, i) => {
        let factor = 1;
        if (i % 2 !== 0) {
          factor = -1;
        }
        node.rotation.z += this._rotationSpeeds[i] * timeElapsed * factor;
      });
    }

    if (this._fixedXAxisPivot.length > 0) {
      this._fixedXAxisPivot.forEach((node, i) => {
        let factor = 1;
        if (i % 2 !== 0) {
          factor = -1;
        }
        node.rotation.x += this._rotationSpeeds[i] * timeElapsed * factor;
      });
    }

    if (this._pivotNodes[0]) {
      this._pivotNodes.forEach((pivotNode, i) => {
        if (i % 2 === 0) {
          pivotNode.rotation.y += this._rotationSpeeds[i] * timeElapsed;
        } else {
          pivotNode.rotation.x += this._rotationSpeeds[i] * timeElapsed;
        }
      });
    }
  }
}
